import { FC } from 'react'
import Image from 'next/image'
import clsx from 'clsx'

import { generateStringTimeFromSec, generateDateTimeFromSec } from 'utils/formatDate'
import { ImageData } from '../../data'

import styles from './card-duration.module.scss'
import commonStyles from 'styles/common/cards.module.scss'

interface ICardDuration {
  duration?: number
  formatString?: boolean
}

const durationSegment = {
  SMALL: 300,
  MIDDLE: 720,
}

const CardDuration: FC<ICardDuration> = ({ duration, formatString }: ICardDuration) => {
  const formattedDurationCommon = generateStringTimeFromSec(duration)
  const formattedDurationDate = generateDateTimeFromSec(duration)

  return duration ? (
    <div
      className={clsx(commonStyles.topCardItem, styles.durationMargin, styles.duration, {
        [styles.messageDurationSmall]: formatString && Number(duration) < durationSegment.SMALL,
        [styles.messageDurationMiddle]:
          formatString &&
          Number(duration) >= durationSegment.SMALL &&
          Number(duration) < durationSegment.MIDDLE,
        [styles.messageDurationLong]: formatString && Number(duration) >= durationSegment.MIDDLE,
      })}
    >
      {formatString ? (
        <>
          <div className={styles.durationImage}>
            <Image {...ImageData.time} />
          </div>
          {formattedDurationCommon}
        </>
      ) : (
        <>{formattedDurationDate}</>
      )}
    </div>
  ) : null
}

export default CardDuration
